import React from "react";

import autobind from "react-autobind";

import {
  ActionButton, Actions, GarbageIcon, GroupButton, isEmpty, ListTable, ListTableAsync, Modal, OptionsTransform, PageTitle, PencilIcon, TabContainer,
  TabPanel
} from "@gsd/backoffice-ui";

import { Column } from "react-table";

import { Button, Col, Row } from "reactstrap";

import { PermissionTableSettings, UserTableSettings } from "./TableSettings";

import _l from "lodash";

import FormUser from "./FormUser";
import FormUserPermission from "./FormUserPermission";
type User = {
  uid?: number;
  email?: string;
  name?: string;
  lastname?: string;
  enabled?: boolean;
  emailVerified?: boolean;
  applications?: Array<unknown>;
};

type Props = {
  loading?: boolean;
  tableData: {
    content: Array<unknown>;
    pageable: {
      pageSize: number;
      pageNumber: number;
    };
    totalElements: number;
    totalPages: number;
  };
  editEntity: Function;
  createEntity: Function;
  deleteEntity: Function;
  setUserAppRoleAcl: Function;
  getAppAcls: Function;
  getOptions: Function;
  deleteUserAppRole: Function;
  searchData: Function;
};

type State = {
  activeDataElement: User | null;
  readOnly: boolean;
  editModalOpen: boolean;
  showPermissionForm: boolean;
  userPermissionData: any;
  disablePermission: boolean;
  formUserPermissionReadOnly: boolean;
  formUserPermissionOptions: {
    optsApplications: Array<{ value: string; lable: string }>;
    optsRoles: Array<{ value: string; lable: string }>;
    optsAcls: Array<{ value: string; lable: string }>;
  };
  allAcls: Array<{ value: string; lable: string }>;
  confirmModalOpen: boolean;
  confirmDeleteUserPermission: { uidApplication?: any; uidRole?: any };
  deleteModalOpen: boolean;
};

class Users extends React.Component<Props, State> {
  static defaultProps: Props = {
    loading: false,
    tableData: {
      content: [],
      pageable: {
        pageSize: 0,
        pageNumber: 0,
      },
      totalElements: 0,
      totalPages: 0,
    },
    editEntity: () => {
      console.log("editEntity");
    },
    deleteEntity: () => {
      console.log("deleteEntity");
    },
    createEntity: () => {
      console.log("createEntity");
    },
    setUserAppRoleAcl: () => {
      console.log("setUserAppRoleAcl");
    },
    getAppAcls: () => {
      console.log("getAppAcls");
    },
    getOptions: () => {
      console.log("getOptions");
    },
    deleteUserAppRole: () => {
      console.log("deleteUserAppRole");
    },
    searchData: () => {
      console.log("searchData");
    },
  };

  state: State;

  queryData: Object = {};

  tableActions: Array<Column> = [
    {
      Header: "Modifica",
      Cell: (row) => {
        return (
          <Actions>
            {!row.original.enabled ? null : (
              <ActionButton
                icon={PencilIcon}
                onClick={() => this.handleEdit(row.original)}
              />
            )}
          </Actions>
        );
      },
      width: 75,
      sortable: false,
    },
    {
      Header: "Elimina",
      Cell: (row) => {
        return (
          <Actions>
            {!row.original.enabled ? null : (
              <ActionButton
                icon={GarbageIcon}
                onClick={() => this.handleConfirmDelete(row.original)}
                shouldCloseOnOverlayClick={true}
              />
            )}
          </Actions>
        );
      },
      width: 75,
      sortable: false,
    },
  ];

  aclActions: Array<Column> = [
    {
      Header: "Modifica",
      Cell: (row) => {
        return (
          <Actions>
            <ActionButton
              icon={PencilIcon}
              onClick={() => this.handleEditPerms(row.original)}
            />
          </Actions>
        );
      },
      width: 75,
      sortable: false,
    },
    {
      Header: "Elimina",
      Cell: (row) => {
        return (
          <Actions>
            <ActionButton
              icon={GarbageIcon}
              onClick={() => this.handleDeletePerms(row.original)}
            />
          </Actions>
        );
      },
      width: 75,
      sortable: false,
    },
  ];

  filterConditions = [
    {
      label: "Tutti",
      condition: null,
    },
    {
      label: "Verificato",
      condition: { field: "emailVerified", value: "true" },
    },
    {
      label: "Non Verificato",
      condition: { field: "emailVerified", value: "false" },
    },
  ];

  constructor(props: Props) {
    super(props);
    this.state = {
      activeDataElement: null,
      userPermissionData: {},
      readOnly: false,
      editModalOpen: false,
      showPermissionForm: false,
      disablePermission: true,
      formUserPermissionReadOnly: false,
      formUserPermissionOptions: {
        optsApplications: [],
        optsRoles: [],
        optsAcls: [],
      },
      allAcls: [],
      confirmModalOpen: false,
      confirmDeleteUserPermission: {},
      deleteModalOpen: false,
    };
    autobind(this);
  }

  componentDidMount = async () => {
    const options = await this.props.getOptions();
    const { applications, roles, acls } = options;
    this.setState({
      ...this.state,
      formUserPermissionOptions: {
        optsApplications: OptionsTransform(applications, "name", "uid"),
        optsRoles: OptionsTransform(roles, "name", "id"),
        optsAcls: [],
      },
      allAcls: acls,
    });
  };

  handleDeletePerms(userPermRow: unknown) {
    this.setState({
      ...this.state,
      confirmModalOpen: true,
      confirmDeleteUserPermission: userPermRow as any,
    });
  }

  handleEditPerms = async (userPermRow: {
    [x: string]: any;
    uidApplication?: any;
    acls?: any;
  }) => {
    const { acls: aclObj, ...rest } = userPermRow;
    const acls = aclObj.map((el) => el.uid);
    const optsAcls = OptionsTransform(
      await this.props.getAppAcls(userPermRow.uidApplication),
      "label",
      "uid"
    );
    const formUserPermissionOptions = {
      ...this.state.formUserPermissionOptions,
      optsAcls,
    };
    this.setState({
      ...this.state,
      showPermissionForm: true,
      userPermissionData: { acls, ...rest },
      formUserPermissionReadOnly: true,
      formUserPermissionOptions,
    });
  };

  handleAddUserPerm() {
    this.setState({
      ...this.state,
      showPermissionForm: true,
      userPermissionData: {
        acl: [],
      },
      formUserPermissionReadOnly: false,
    });
  }

  deletePerms = async () => {
    const { uidApplication, uidRole } = this.state.confirmDeleteUserPermission;
    const activeDataElement = await this.props.deleteUserAppRole({
      applicationId: uidApplication,
      roleId: uidRole,
      userId: (this.state.activeDataElement || {}).uid,
    });

    this.setState({
      ...this.state,
      activeDataElement,
      confirmModalOpen: false,
      confirmDeleteUserPermission: {},
    });
  };

  closeEditPermsForm() {
    this.setState({
      ...this.state,
      showPermissionForm: false,
      userPermissionData: {},
    });
  }

  handleEdit(row: { uid?: any }) {
    const disablePermission = (row.uid || 0) > 0 ? false : true;
    this.setState({
      ...this.state,
      editModalOpen: true,
      disablePermission,
      activeDataElement: row || {},
    });
  }

  handleDeleteUser(values: unknown) {
    console.log("handleDeleteUser", values);
    this.props.deleteEntity(values);
  }

  handleConfirmDelete(row: unknown) {
    this.setState({
      ...this.state,
      activeDataElement: row || null,
      deleteModalOpen: true,
    });
  }

  closeDeleteModal() {
    this.setState({
      ...this.state,
      deleteModalOpen: false,
      activeDataElement: null,
    });
  }

  newUser() {
    this.setState({
      ...this.state,
      editModalOpen: true,
      activeDataElement: null,
    });
  }

  onCloseModal() {
    this.setState({
      ...this.state,
      editModalOpen: false,
      showPermissionForm: false,
      disablePermission: true,
    });
  }

  onCloseConfirmModal() {
    this.setState({
      ...this.state,
      confirmModalOpen: false,
    });
  }

  onSaveUser(values: { uid: any }) {
    if ((values.uid || 0) !== 0) {
      this.props.editEntity(values);
    } else {
      this.props.createEntity(values);
    }
    this.onCloseModal();
  }

  onAddUserPermission = async (values: {
    uidApplication?: any;
    uidRole?: any;
    acls?: any;
  }) => {
    const {
      uidApplication: applicationId,
      uidRole: roleId,
      acls: aclIds,
    } = values;
    const userId = (this.state.activeDataElement || {}).uid;
    const obj = {
      applicationId,
      roleId,
      aclIds,
      userId,
    };
    const activeDataElement = await this.props.setUserAppRoleAcl(obj);
    this.setState({
      ...this.state,
      showPermissionForm: false,
      activeDataElement,
    });
  };

  onCancelPermission() {
    this.setState({
      ...this.state,
      showPermissionForm: false,
    });
  }

  _flatApplication(data) {
    const res = [] as any[];
    const { allAcls } = this.state;
    data.map((application) => {
      const { uid: uidApplication, roles, ...restApplication } = application;
      const appRoles = roles.map((role) => {
        const {
          name: roleName,
          description: roleDescription,
          id: uidRole,
          acl,
          ...restRole
        } = role;
        const userAppRoleAcls = _l.flatten(
          _l.map(acl, function (item) {
            return _l.filter(allAcls, item);
          })
        );
        return {
          uidApplication,
          ...restApplication,
          uidRole,
          roleName,
          roleDescription,
          ...restRole,
          acls: userAppRoleAcls,
        };
      });
      return res.push(...appRoles);
    });
    return res;
  }

  _getAppAcls = async (appUid) => {
    const optsAcls = OptionsTransform(
      await this.props.getAppAcls(appUid),
      "label",
      "uid"
    );
    const formUserPermissionOptions = {
      ...this.state.formUserPermissionOptions,
      optsAcls,
    };
    this.setState({
      ...this.state,
      formUserPermissionOptions,
      userPermissionData: {
        ...this.state.userPermissionData,
        acl: [],
      },
    });
  };

  searchData = async (searchData: {
    tableState: any;
    searchTerm: any;
    filterConditions: any;
    opt: any;
    sortConditions: any;
  }) => {
    const {
      tableState: { page = 0, pageSize = 20 } = {},
      searchTerm = "",
      filterConditions = [],
      opt = {},
      sortConditions = [],
    } = searchData || {};
    const queryData: {
      page: any;
      size: any;
      query?: any;
      type?: any;
    } = {
      page,
      size: pageSize,
    };
    if (!isEmpty(searchTerm)) queryData.query = searchTerm;
    if (!isEmpty(filterConditions)) {
      filterConditions.forEach((filter) => {
        queryData[filter.field] = filter.value;
      });
    }
    if (!isEmpty(opt)) {
      queryData.type = opt.label;
    }
    if (!isEmpty(sortConditions)) {
      sortConditions.forEach((cond) => {
        const desc = cond.desc ? "desc" : "asc";
        queryData["sort"] = `${cond.id},${desc}`;
      });
    }
    if (queryData !== this.queryData) {
      await this.props.searchData(queryData);
      this.queryData = queryData;
    }
  };

  render() {
    const { tableData: { content: dataElements = [], totalPages = 0 } = {}} =
      this.props || {};

    const {
      editModalOpen,
      activeDataElement,
      showPermissionForm,
      userPermissionData,
      disablePermission,
      formUserPermissionReadOnly,
      formUserPermissionOptions,
      confirmModalOpen,
      deleteModalOpen,
    } = this.state;
    const applications = _l.get(activeDataElement, "applications", []);
    const flatAppData = this._flatApplication(applications);
    console.log([...this.tableActions, ...UserTableSettings]);
    return (
      <React.Fragment>
        <Row className="pb-3">
          <Col xs="9">
            <PageTitle title="Utenti e permessi" />
          </Col>
          <Col xs="3">
            <Button color="primary" size="lg" block onClick={this.newUser}>
              Nuovo Utente
            </Button>
          </Col>
        </Row>
        <ListTableAsync
          columns={[...this.tableActions, ...UserTableSettings]}
          data={dataElements}
          onSearch={this.searchData}
          pages={totalPages}
          fullSearch
          filterComponents={[
            <GroupButton key={"filters"} buttons={this.filterConditions} />,
          ]}
          defaultSorted={[
            {
              id: "email",
            },
          ]}
        />
        <Modal
          showModal={deleteModalOpen}
          onClose={() => this.closeDeleteModal()}
          title="Elimina Utente"
          size="sm"
        >
          <div className="text-center">
            <h3>Vuoi eliminare l&apos;utente</h3>
          </div>
          <div className="my-3 d-flex justify-content-center">
            {["email", "name", "lastname"].map((el, key) => {
              return (
                <div key={key} className="mr-3">
                  {_l.get(activeDataElement, el, "")}
                </div>
              );
            })}
          </div>
          <div className="text-center">
            <Button
              color="primary"
              className="px-5 mr-5"
              onClick={() => {
                this.handleDeleteUser(activeDataElement);
                this.closeDeleteModal();
              }}
            >
              Si
            </Button>
            <Button
              color="secondary"
              className="px-5"
              onClick={() => {
                this.closeDeleteModal();
              }}
            >
              No
            </Button>
          </div>
        </Modal>
        <Modal
          showModal={editModalOpen}
          onClose={() => this.onCloseModal()}
          size="lg"
          title={`${
            (activeDataElement || {}).uid || false ? "Modifica" : "Nuovo"
          } Utente`}
        >
          <TabContainer>
            <TabPanel caption="Anagrafica" name="formuser">
              <FormUser
                initialValues={activeDataElement as any}
                onSubmit={this.onSaveUser as any}
              />
            </TabPanel>
            <TabPanel
              caption="Permessi"
              name="permission"
              disable={disablePermission}
            >
              <div className="my-2">
                <Row>
                  <Col xs="10">
                    <h3>
                      <span>
                        {(activeDataElement || {}).name || ""}{" "}
                        {(activeDataElement || {}).lastname || ""}{" "}
                      </span>
                      <small className="text-muted">
                        {(activeDataElement || {}).email || ""}
                      </small>
                    </h3>
                  </Col>
                  <Col xs="2">
                    {showPermissionForm ? null : (
                      <Button color="primary" onClick={this.handleAddUserPerm}>
                        Aggiungi Permesso
                      </Button>
                    )}
                  </Col>
                </Row>
              </div>
              {showPermissionForm ? (
                <div className="pb-3">
                  <FormUserPermission
                    options={formUserPermissionOptions}
                    initialValues={userPermissionData}
                    onSubmit={this.onAddUserPermission}
                    onCancel={this.onCancelPermission}
                    onChangeAppUid={this._getAppAcls}
                    readOnly={formUserPermissionReadOnly}
                  />
                </div>
              ) : null}
              {isEmpty((activeDataElement || {}).applications) ? null : (
                <ListTable
                  columns={PermissionTableSettings}
                  data={flatAppData}
                  pivotBy={["name"]}
                  actions={this.aclActions}
                  showPagination={false}
                  collapseOnDataChange={false}
                />
              )}
            </TabPanel>
          </TabContainer>
        </Modal>
        <Modal
          showModal={confirmModalOpen}
          onClose={() => this.onCloseConfirmModal()}
          title={"Conferma elimininazione Ruolo Utente"}
        >
          <div className="text-center">
            <h3 className="text-primary">Stai per elimnare un ruolo utente</h3>
            <br />
            <span>
              Conferma cliccando sul pulsante elimina o usa il pulsante annulla
              per annullare l'operazione
            </span>
          </div>
          <hr />
          <div className="d-flex justify-content-between">
            <Button color="primary" onClick={this.deletePerms}>
              Elimina
            </Button>
            <Button
              className="btn btn-light"
              onClick={this.onCloseConfirmModal}
            >
              Annulla
            </Button>
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}
export default Users;
